var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJozunaLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 233,
    height: 59,
    viewBox: "0 0 233 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11731_4640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.1836 37.9568H79.2921V45.8799C79.2921 46.6288 79.4318 47.149 79.7171 47.452C79.9965 47.7492 80.5378 47.8978 81.3411 47.8978H83.035C83.8325 47.8978 84.3622 47.7492 84.6241 47.452C84.8802 47.1547 85.0141 46.6288 85.0141 45.8799V7.31641H93.1925V47.0747C93.1925 49.4184 92.5813 51.2363 91.3589 52.5282C90.1365 53.8258 88.1865 54.4718 85.5089 54.4718H78.8789C76.1547 54.4718 74.1872 53.8258 72.9939 52.5282C71.7948 51.2363 71.1952 49.4127 71.1952 47.0747V37.9568H71.1836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.452 15.9083V36.3105H97.3438V14.7136C97.3438 12.3698 97.955 10.5519 99.1773 9.26002C100.4 7.96809 102.35 7.31641 105.027 7.31641H109.824V13.8904H107.495C106.698 13.8904 106.157 14.0276 105.871 14.302C105.592 14.5764 105.446 15.1137 105.446 15.9083H105.452ZM105.452 33.3951V45.8742C105.452 46.6231 105.592 47.1433 105.877 47.4462C106.157 47.7435 106.698 47.8921 107.501 47.8921H109.76V54.4661H105.033C102.356 54.4661 100.406 53.8201 99.1832 52.5225C97.9608 51.2306 97.3496 49.407 97.3496 47.0689V33.3951H105.458H105.452ZM113.206 45.8742V33.7667H121.314V47.0689C121.314 49.4127 120.715 51.2306 119.516 52.5225C118.317 53.8201 116.355 54.4661 113.631 54.4661H108.555V47.8921H111.232C112.03 47.8921 112.56 47.7435 112.822 47.4462C113.078 47.149 113.212 46.6231 113.212 45.8742H113.206ZM113.206 36.3105V15.9083C113.206 15.1137 113.078 14.5764 112.816 14.302C112.56 14.0276 112.03 13.8904 111.227 13.8904H108.828V7.31641H113.625C116.349 7.31641 118.317 7.96237 119.51 9.26002C120.709 10.5577 121.308 12.3755 121.308 14.7136V36.3105H113.2H113.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.38 13.8902H146.698L131.541 47.892H123.223L138.38 13.8902ZM146.349 47.892V54.466H123.223V47.892H146.349ZM146.704 7.31055V13.8845H124.003V7.31055H146.704Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.851 7.31641V45.8799C156.851 46.6288 156.99 47.149 157.276 47.452C157.555 47.7492 158.073 47.8978 158.824 47.8978H161.083V54.4718H156.432C153.702 54.4718 151.74 53.8258 150.541 52.5282C149.342 51.2363 148.742 49.4127 148.742 47.0747V7.31641H156.851ZM164.604 45.8799V7.31641H172.713V47.0747C172.713 49.4184 172.102 51.2363 170.879 52.5282C169.657 53.8258 167.707 54.4718 165.029 54.4718H159.953V47.8978H162.561C163.359 47.8978 163.9 47.7492 164.185 47.452C164.465 47.1547 164.61 46.6288 164.61 45.8799H164.604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.435 7.31641H201.839V54.4718H194.226L184.708 23.2311V54.4718H177.234V7.31641H185.064L194.441 38.1055V7.31641H194.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233 54.4718H224.822L218.122 15.611L211.847 54.4718H203.738L212.691 7.31641H223.623L233 54.4718ZM226.725 38.1798V44.6794H209.943V38.1798H226.725Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.1841 1.78432C38.7278 4.19097 38.7627 8.12964 36.2655 10.582C33.7684 13.0344 29.6763 13.0687 27.1325 10.662C24.5888 8.2554 24.5538 4.31673 27.051 1.86436C29.5482 -0.588023 33.6403 -0.622322 36.1841 1.78432Z",
    fill: "url(#paint0_linear_11731_4640)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.3963 23.6508L51.2893 20.8154L42.2436 12.2578L39.3506 15.0932C35.2003 19.1633 28.3549 19.2205 24.1289 15.2247L21.1835 12.435L12.3008 21.1527L15.2462 23.9423C24.4432 32.6486 39.3623 32.5171 48.3963 23.6565",
    fill: "url(#paint1_linear_11731_4640)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.9374 54.0615C55.5845 55.2391 51.8824 53.5699 50.66 50.3401C49.4376 47.1102 51.1664 43.5374 54.5193 42.3656C57.8721 41.1937 61.5742 42.8572 62.7966 46.087C64.019 49.3168 62.2902 52.8896 58.9374 54.0615Z",
    fill: "url(#paint2_linear_11731_4640)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1967 55.2679L34.6111 59.0065L46.5266 54.8277L45.1121 51.0891C43.0864 45.727 45.9852 39.7476 51.5442 37.7982L55.421 36.4377L51.0844 24.959L47.2076 26.3195C35.0943 30.5669 28.7902 43.5948 33.1967 55.2736",
    fill: "url(#paint3_linear_11731_4640)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.24976 54.0618C7.60261 55.2394 11.3047 53.5702 12.5271 50.3404C13.7495 47.1106 12.0207 43.5378 8.66784 42.3659C5.31499 41.1883 1.61288 42.8575 0.390483 46.0873C-0.831911 49.3171 0.896904 52.89 4.24976 54.0618Z",
    fill: "url(#paint4_linear_11731_4640)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9899 55.2679L28.5754 59.0065L16.66 54.8277L18.0745 51.0891C20.1002 45.727 17.2013 39.7476 11.6424 37.7982L7.76562 36.4377L12.1022 24.959L15.979 26.3195C28.0923 30.5669 34.3964 43.5948 29.9899 55.2736",
    fill: "url(#paint5_linear_11731_4640)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11731_4640",
    x1: 25.2,
    y1: 6.22605,
    x2: 38.1166,
    y2: 6.22605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E61AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#19569B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175193"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11731_4640",
    x1: 12.3008,
    y1: 21.3185,
    x2: 51.2893,
    y2: 21.3185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E61AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#19569B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#175193"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11731_4640",
    x1: 50.27,
    y1: 48.2135,
    x2: 63.1866,
    y2: 48.2135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AAD7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#109B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C9366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11731_4640",
    x1: 31.788,
    y1: 41.977,
    x2: 55.421,
    y2: 41.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AAD7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#109B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C9366"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_11731_4640",
    x1: 0.00048122,
    y1: 48.2139,
    x2: 12.9171,
    y2: 48.2139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C36913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_11731_4640",
    x1: 7.76562,
    y1: 41.977,
    x2: 31.3986,
    y2: 41.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C36913"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11731_4640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 233,
    height: 59,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJozunaLogo);
export default __webpack_public_path__ + "static/media/jozuna_logo.01dc13b687b7b060dc08f53406ec04ba.svg";
export { ForwardRef as ReactComponent };